import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { isArray, isEmpty } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container, OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'react-multi-select-component';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import io from 'socket.io-client';
import * as XLSX from 'xlsx';
import iconBlackWhite from '../../../assets/images/icon-black-white.svg';
import iconColoured from '../../../assets/images/icon-coloured.svg';
import { checkArray } from '../../../Components/helper';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import Loader from '../../../Components/Utility/Loader/Loader';
import ProductCostingTabMenu from '../../../Components/GreedyNavBar/ProductCostingTabMenu';
import ErrorModal from '../../Library/BomLibrary/ErrorModal';
import ImportModal from '../../Library/BomLibrary/ImportModal';
import * as CostingTemplateAction from '../../Library/CostingTemplateTSX/store/costingTemplate.actions';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import '../RangePlan.css';
import AllInformationTabs from './AllInformationTabs';
import BulkCostingExchangeModal from './BulkCostingExchangeModal';
import BulkManualModal from './BulkManualModal';
import ProductInfoCustomSections from './ExpandViewModules/ProductInfoCustomSections';
import FilterProductList from './FilterProductList';
import ProductFieldsModal from './ProductFieldsModal';
import { useProductListingState } from './RangePlanProductListingProvider';
import ProductBOM from './RangePlanTables/ProductBOM';
import ProductCareDocument from './RangePlanTables/ProductCareDocument';
import ProductCareLabel from './RangePlanTables/ProductCareLabel';
import { ProductCostingTable } from './RangePlanTables/productCostingTable';
import ProductIdentifierV2 from './RangePlanTables/ProductIdentifierV2/ProductIdentifierV2';
import {
  RP_IDENTIFIER_API_NAME,
  RP_IDENTIFIER_DOWNLOAD_KEY,
  RP_IDENTIFIER_FILE_TYPE,
  RP_IDENTIFIER_TAB_KEY,
} from './RangePlanTables/ProductIdentifierV2/product-identifier-v2.constants';
import ProductInfoTabel from './RangePlanTables/ProductInfo';
import ProductSample from './RangePlanTables/ProductSample';
import ProductSpecification from './RangePlanTables/ProductSpecification';
import ProductTesting from './RangePlanTables/ProductTesting';
import Suppliers from './RangePlanTables/SupplierTable';
import SearchBarNew from '../../../Components/Utility/FilterAction/SearchBarNew';
import * as ProductListAction from './store/ProductList.action';
import * as ProductListService from '../../../services/ProductList.services';
import { getPreWriteSignedWriteUrl, getPreReadSignedWriteUrl } from '../../../services/s3Services';
import { registerCareUpload, registerTestingUpload, getCurrentSocketId } from '../../../socket';
import { useCostingAccess } from '../../../Components/CustomHooks/useCostingAccess';
import { isIdentifierUploadAllowed } from './RangePlanTables/ProductIdentifierV2/identifier-upload-access';
import { runSingleFlight } from './rangePlanUploadPrompt';

const CUSTOM_SECTION_API_NAME = 'customsection';
const CUSTOM_SECTION_PAGE_SIZE = 20;

function ProductListNew() {
  const { t } = useTranslation('common');
  const reducers = useSelector((redState) => redState);
  const {
    ProductListData: {
      filterSelectedData,
      filterSelectedData: { pageIndex, pageSize },
      customSectionsArr,
      rangePlanCardDetail,
      customSectionData,
      customAttributes,
      rangePlanProductInfo,
    },
    Users: { logInRights },
    SystemMastersDetails: { subBrandAccess },
    UserDetails: { userInfo, isCompanyAdminLoggedIn },
    CostingTemplateData: { costingTemplateList },
    CostingTodoListData: { costingSelectedIds: reduxCostingSelectedIds, costingListData: reduxCostingListData, costingFilterValues = {} } = {},
  } = reducers;
  const docRef = useRef(null);
  const subBrandRef = useRef(null);
  const { rangeplanId } = useParams();
  const location = useLocation();
  const history = useHistory();
  const isCardView = location.pathname.includes('/visual-view');
  const colouredCardFaces = isCardView;

  const [state, setState] = useState({
    isSelectAll: false,
    selectedIds: [],
    selectedCostingIds: [],
    selectedCombinations: [],
    exchangeRateModal: false,
    exchangeRate: '',
    exchangeLoader: false,
    errors: false,
    isManualModal: false,
    isProductFieldModal: false,
    spinnerLoder: false,
    selectedInfo: [],
    excludeProductImage: false,
    downloadLoading: false,
    loadNextData: false,
    showUploadModal: false,
    showErrModal: false,
    activeCustomIndex: null,
    activeCustomSectiondata: null,
    dupModalOpen: false,
    dupData: null,
    selectedCostingTemplate: null,
    colouredFaces: false,
    colouredCardFaces: false,
  });
  const {
    isSelectAll,
    selectedIds,
    selectedCostingIds,
    selectedCombinations,
    exchangeRateModal,
    exchangeRate,
    exchangeLoader,
    errors,
    isManualModal,
    isProductFieldModal,
    excludeProductImage,
    downloadLoading,
    loadNextData,
    showUploadModal,
    showErrModal,
    activeCustomSectiondata,
    dupModalOpen,
    dupData,
    selectedCostingTemplate,
    colouredFaces,
  } = state;

  const [costingDataLoading, setCostingDataLoading] = useState(false);

  const { timeZone } = window?.Intl?.DateTimeFormat()?.resolvedOptions() || 'Asia/Kolkata';
  const dispatch = useDispatch();
  const {
    rangePlanProvider: { productsList, productsNumber, RPActiveTab, mainLoader, isNoteVisible, notes },
    setRangePlanProvider,
  } = useProductListingState();
  const { CheckActionPermission, CheckModulePermission } = useComponent();
  const hasCostingAccess = useCostingAccess();
  const rangePlanAddEditAccess = CheckActionPermission(logInRights, 'rangePlan', 'default', 'addEdit');
  const costingAddEditAccess = CheckActionPermission(logInRights, 'products', 'costing', 'addEdit');
  const productIdentifierTabAccess = CheckModulePermission(logInRights, 'rangePlan', 'productIdentifier', isCompanyAdminLoggedIn);
  const productIdentifierAddEditAccess = CheckActionPermission(logInRights, 'rangePlan', 'productIdentifier', 'addEdit');
  const identifierUploadAllowed = isIdentifierUploadAllowed(RPActiveTab, productIdentifierAddEditAccess);
  const identifierTabReadOnly = RPActiveTab === RP_IDENTIFIER_TAB_KEY && !productIdentifierAddEditAccess;
  const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';
  const localStorageFilter = JSON.parse(localStorage.getItem(storageKey));
  const productInfo = 'product-info';
  const productIdentifier = 'product-identifier';
  const productSupplier = 'supplier-info';
  const productBOM = 'bom-info';
  const productTesting = 'productTesting';
  const productSpecificaion = 'specification';
  const careLabelInfo = 'care-label-info';
  const careLabelDocument = 'care-label-document';
  const productSample = 'samples';
  const productCostingModuleName = 'product-costing';

  const uploadXlsxAccessModule = [productInfo, productIdentifier, productBOM, productTesting, careLabelInfo];
  const downloading = 'COMMON_LABEL.DOWNLOADING';
  const tabsArray = [
    {
      eventKey: productInfo,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.PRODUCT_INFORMATION',
    },
    {
      eventKey: productIdentifier,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.PRODUCT_IDENTIFIER',
    },
    {
      eventKey: productSupplier,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.SUPPLIER_INFORMATION',
    },
    {
      eventKey: productBOM,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.BOM_INFORMATION',
    },
    {
      eventKey: productSpecificaion,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.SPECIFICATION_INFORMATION',
    },
    {
      eventKey: productTesting,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.TESTING_INFORMATION',
    },
    {
      eventKey: careLabelInfo,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.CARE/USER_INFORMATION',
    },
    {
      eventKey: careLabelDocument,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.CARE/USER_DOCUMENTS_INFORMATION',
    },
    {
      eventKey: productSample,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.SAMPLE_INFORMATION',
    },
    {
      eventKey: productCostingModuleName,
      eventName: 'PRODUCT_LIST.ALL_INFORMATION.COSTING_INFORMATION',
    },
  ];

  const [menuList, setMenuList] = useState([]);
  const [displayCustomSection, setDisplayCustomSection] = useState([]);
  const [loader2, setLoader2] = useState(true);

  const [selectedCardAttributes, setSelectedCardAttributes] = useState([]);
  const getAvailableCardAttributes = useCallback(() => {
    const standardAttributes = [
      { label: t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_NUMBER'), value: 'number', sequenceId: 1, group: null },
      { label: t('RANGE_PLANS.PRODUCT_LIST.DESCRIPTION'), value: 'description', sequenceId: 2, group: null },
      { label: t('RANGE_PLANS.PRODUCT_LIST.BRAND'), value: 'brand', sequenceId: 3, group: 'Brand' },
      ...(subBrandAccess ? [{ label: t('RANGE_PLANS.PRODUCT_LIST.SUB_BRAND'), value: 'subBrand', sequenceId: 4, group: 'Brand' }] : []),
      { label: t('RANGE_PLANS.PRODUCT_LIST.SEASON'), value: 'season', sequenceId: 5, group: 'Season' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.MONTH'), value: 'month', sequenceId: 6, group: 'Season' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.YEAR'), value: 'year', sequenceId: 7, group: 'Season' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_TYPE'), value: 'productType', sequenceId: 8, group: null },
      { label: t('RANGE_PLANS.PRODUCT_LIST.CATEGORY_1'), value: 'category1', sequenceId: 9, group: 'Categories' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.CATEGORY_2'), value: 'category2', sequenceId: 10, group: 'Categories' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.CATEGORY_3'), value: 'category3', sequenceId: 11, group: 'Categories' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.CATEGORY_4'), value: 'category4', sequenceId: 12, group: 'Categories' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.STATUS'), value: 'status', sequenceId: 13, group: null },
      { label: t('RANGE_PLANS.PRODUCT_LIST.COLOURWAY_NAME'), value: 'colourway', sequenceId: 14, group: null },
      { label: t('RANGE_PLANS.PRODUCT_LIST.SUPPLIER'), value: 'supplier', sequenceId: 15, group: null },
      { label: t('RANGE_PLANS.PRODUCT_LIST.FACTORY'), value: 'factory', sequenceId: 16, group: null },
      { label: t('SYSTEM_MASTERS.LICENSOR_MASTER.LICENSOR'), value: 'licensor', sequenceId: 17, group: 'Licences' },
      { label: t('SYSTEM_MASTERS.LICENSE_MASTER.LICENSE'), value: 'license', sequenceId: 18, group: 'Licences' },
      { label: t('RANGE_PLANS.PRODUCT_LIST.LIKENESS'), value: 'likeness', sequenceId: 19, group: 'Licences' },
    ];
    const customAttrs =
      customAttributes
        ?.filter((attr) => (attr.type === 'dropdown' && attr.isLable === true) || (attr.type === 'text' && attr.isLable === false))
        ?.map((attr, index) => ({
          label: attr.keyName,
          value: `custom_${attr._id}`,
          sequenceId: standardAttributes.length + index + 1,
          isCustom: true,
          customData: attr,
          group: null,
        })) || [];
    return [...standardAttributes, ...customAttrs];
  }, [t, customAttributes, subBrandAccess]);

  const getGroupedCardAttributes = useCallback(() => {
    const allAttributes = getAvailableCardAttributes();
    const filteredAttributes = allAttributes.filter((attr) => attr.value !== 'number');
    const grouped = {};

    filteredAttributes.forEach((attr) => {
      const groupName = attr.group || 'Other';
      if (!grouped[groupName]) {
        grouped[groupName] = [];
      }
      grouped[groupName].push(attr);
    });

    const groupOrder = ['Season', 'Categories', 'Licences', 'Brand', 'Other'];
    const result = [];

    groupOrder.forEach((groupName) => {
      if (grouped[groupName] && grouped[groupName].length > 0) {
        if (groupName !== 'Other') {
          if (groupName === 'Brand' && grouped[groupName].length === 1 && !subBrandAccess) {
            const brandAttr = grouped[groupName][0];
            result.push({
              ...brandAttr,
              groupLabel: undefined,
            });
          } else {
            result.push({
              label: groupName,
              value: `group_${groupName}`,
              isGroup: true,
              groupName,
              children: grouped[groupName],
              sequenceId: grouped[groupName][0].sequenceId,
            });
          }
        } else {
          grouped[groupName].forEach((attr) => {
            result.push({
              ...attr,
              groupLabel: undefined,
            });
          });
        }
      }
    });

    return result.sort((a, b) => {
      const aSeq = a.sequenceId || (a.isGroup ? a.children?.[0]?.sequenceId : 999);
      const bSeq = b.sequenceId || (b.isGroup ? b.children?.[0]?.sequenceId : 999);
      return aSeq - bSeq;
    });
  }, [getAvailableCardAttributes, subBrandAccess]);

  const CARD_ATTRIBUTES_STORAGE_KEY = 'rangePlan_selectedCardAttributes';

  const loadSelectedAttributesFromStorage = useCallback(() => {
    try {
      const stored = localStorage.getItem(CARD_ATTRIBUTES_STORAGE_KEY);
      if (stored) {
        const parsedStored = JSON.parse(stored);
        const allAttributes = getAvailableCardAttributes();
        const grouped = {};

        allAttributes.forEach((attr) => {
          const groupName = attr.group || 'Other';
          if (!grouped[groupName]) {
            grouped[groupName] = [];
          }
          grouped[groupName].push(attr);
        });

        const validStoredAttrs = parsedStored
          .map((storedAttr) => {
            if (storedAttr.isGroup && storedAttr.value?.startsWith('group_')) {
              const groupName = storedAttr.groupName || storedAttr.value.replace('group_', '');
              if (grouped[groupName] && grouped[groupName].length > 0) {
                const filteredChildren = grouped[groupName].filter((child) => {
                  if (!subBrandAccess && child.value === 'subBrand') {
                    return false;
                  }
                  return true;
                });

                if (filteredChildren.length === 0) {
                  return null;
                }

                if (groupName === 'Brand' && filteredChildren.length === 1 && !subBrandAccess) {
                  return filteredChildren[0];
                }

                return {
                  label: groupName,
                  value: storedAttr.value,
                  isGroup: true,
                  groupName,
                  children: filteredChildren,
                  sequenceId: filteredChildren[0].sequenceId,
                };
              }
              return null;
            }
            if (!subBrandAccess && storedAttr.value === 'subBrand') {
              return null;
            }
            const availableAttr = allAttributes.find((attr) => attr.value === storedAttr.value);
            return availableAttr || null;
          })
          .filter((attr) => attr !== null);

        if (validStoredAttrs.length > 0) {
          const cleanedAttrs = validStoredAttrs.sort((a, b) => a.sequenceId - b.sequenceId);
          saveSelectedAttributesToStorage(cleanedAttrs);
          return cleanedAttrs;
        }
      }
    } catch (error) {
      console.error('Error loading card attributes from localStorage:', error);
    }

    return [];
  }, [getAvailableCardAttributes, subBrandAccess]);

  const saveSelectedAttributesToStorage = useCallback((attributes) => {
    try {
      localStorage.setItem(CARD_ATTRIBUTES_STORAGE_KEY, JSON.stringify(attributes));
    } catch (error) {
      console.error('Error saving card attributes to localStorage:', error);
    }
  }, []);

  useEffect(() => {
    if (selectedCardAttributes.length === 0 && customAttributes !== undefined) {
      const attributesToLoad = loadSelectedAttributesFromStorage();
      if (attributesToLoad.length > 0) {
        setSelectedCardAttributes(attributesToLoad);
      }
    }
  }, [loadSelectedAttributesFromStorage, selectedCardAttributes.length, customAttributes]);

  useEffect(() => {
    if (!subBrandAccess && selectedCardAttributes.length > 0) {
      const cleanedAttributes = selectedCardAttributes
        .map((attr) => {
          if (attr.isGroup && attr.groupName === 'Brand' && attr.children) {
            const filteredChildren = attr.children.filter((child) => child.value !== 'subBrand');
            if (filteredChildren.length === 0) {
              return null;
            }
            if (filteredChildren.length === 1) {
              return filteredChildren[0];
            }
            return {
              ...attr,
              children: filteredChildren,
            };
          }
          if (attr.value === 'subBrand') {
            return null;
          }
          return attr;
        })
        .filter((attr) => attr !== null);

      if (cleanedAttributes.length !== selectedCardAttributes.length) {
        setSelectedCardAttributes(cleanedAttributes);
        saveSelectedAttributesToStorage(cleanedAttributes);
      }
    }
  }, [subBrandAccess, selectedCardAttributes, saveSelectedAttributesToStorage]);

  const handleCardAttributeChange = (selected) => {
    const allAttributes = getAvailableCardAttributes();
    const finalSelected = [];

    selected.forEach((item) => {
      if (item.isGroup && item.children) {
        const filteredChildren = item.children.filter((child) => {
          if (!subBrandAccess && child.value === 'subBrand') {
            return false;
          }
          return true;
        });

        if (filteredChildren.length === 0) {
          return;
        }

        if (item.groupName === 'Brand' && filteredChildren.length === 1 && !subBrandAccess) {
          finalSelected.push(filteredChildren[0]);
        } else {
          finalSelected.push({
            label: item.groupName,
            value: item.value,
            isGroup: true,
            groupName: item.groupName,
            children: filteredChildren,
            sequenceId: filteredChildren[0].sequenceId,
          });
        }
      } else if (!item.isGroup && !item.value.startsWith('group_')) {
        if (!subBrandAccess && item.value === 'subBrand') {
          return;
        }
        const fullAttr = allAttributes.find((attr) => attr.value === item.value);
        if (fullAttr) {
          finalSelected.push(fullAttr);
        }
      }
    });

    if (finalSelected.length <= 5) {
      const sortedSelected = finalSelected.sort((a, b) => a.sequenceId - b.sequenceId);
      setSelectedCardAttributes(sortedSelected);
      saveSelectedAttributesToStorage(sortedSelected);
    } else {
      toasterMsg(t('RANGE_PLANS.PRODUCT_LIST.MAX_5_ATTRIBUTES_ALLOWED'), 'warning');
      const currentSelected = selectedCardAttributes.filter((attr) =>
        selected.some((sel) => {
          if (sel.isGroup) {
            return sel.value === attr.value;
          }
          return sel.value === attr.value;
        }),
      );
      setSelectedCardAttributes(currentSelected);
    }
  };

  const cardKeyToTabEventKeyMap = {
    productInformation: productInfo,
    productIdentifier,
    supplier: productSupplier,
    bom: productBOM,
    specifications: productSpecificaion,
    testing: productTesting,
    careUser: careLabelInfo,
    careUserLayout: careLabelDocument,
    sampling: productSample,
    costing: productCostingModuleName,
  };

  const costingTemplateListOptions = useMemo(() => {
    return costingTemplateList?.map((item) => ({
      eventKey: item?._id,
      eventName: item?.name,
      isDefaultTab: item?.isDefaultTab,
    }));
  }, [costingTemplateList?.length]);
  const getMergedFilterData = () => {
    const cardDetails = rangePlanCardDetail;
    const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';
    const localStorageFilter = JSON.parse(localStorage.getItem(storageKey)) || {};
    const mergeArrays = (cardArray, localArray) => {
      const localIds = Array.isArray(localArray) ? localArray : [];
      if (localIds.length > 0) {
        return localIds;
      }

      return Array.isArray(cardArray)
        ? cardArray.map((item) => (typeof item === 'string' || typeof item === 'number' ? item : item._id || item.id || item)).filter((id) => id)
        : [];
    };

    const mergeSingleValue = (cardValue, localValue) => {
      if (localValue !== null && localValue !== undefined && localValue !== '') {
        return localValue;
      }
      if (cardValue) {
        if (typeof cardValue === 'string' || typeof cardValue === 'number') {
          return cardValue;
        }
        if (Array.isArray(cardValue) && cardValue.length > 0) {
          const firstItem = cardValue[0];
          return typeof firstItem === 'string' || typeof firstItem === 'number' ? firstItem : firstItem._id || firstItem.id || firstItem;
        }
        return cardValue._id || cardValue.id || cardValue;
      }
      return localValue;
    };

    return {
      brandId: mergeArrays(cardDetails?.brand, localStorageFilter?.selectedBrand || filterSelectedData?.selectedBrand),
      seasonId: mergeArrays(cardDetails?.season, localStorageFilter?.selectedSeason || filterSelectedData?.selectedSeason),
      year: mergeArrays(cardDetails?.year, localStorageFilter?.selectedYear || filterSelectedData?.selectedYear),
      month: mergeArrays(cardDetails?.month, localStorageFilter?.selectedMonth || filterSelectedData?.selectedMonth),
      supplierId: mergeArrays(cardDetails?.supplier, localStorageFilter?.selectedSupplier || filterSelectedData?.selectedSupplier),
      catOneId: mergeArrays(cardDetails?.catOneId, localStorageFilter?.selectedCat1 || filterSelectedData?.selectedCat1),
      catTwoId: mergeArrays(cardDetails?.catTwoId, localStorageFilter?.selectedCat2 || filterSelectedData?.selectedCat2),
      catThreeId: mergeArrays(cardDetails?.catThreeId, localStorageFilter?.selectedCat3 || filterSelectedData?.selectedCat3),
      catFourId: mergeArrays(cardDetails?.catFourId, localStorageFilter?.selectedCat4 || filterSelectedData?.selectedCat4),
      createdBy: localStorageFilter?.selectedCompanyUser || filterSelectedData?.selectedCompanyUser,
      statusId: mergeArrays(cardDetails?.status, localStorageFilter?.selectedStatus || filterSelectedData?.selectedStatus),
      productType: mergeArrays(cardDetails?.productType, localStorageFilter?.selectedProductType || filterSelectedData?.selectedProductType),
      dynamicTypes: localStorageFilter?.selectedDynamic || filterSelectedData?.selectedDynamic,
      COO: mergeArrays(cardDetails?.COO, localStorageFilter?.selectedCoo || filterSelectedData?.selectedCoo),
      productGroupId: mergeSingleValue(cardDetails?.productGroupId, localStorageFilter?.productGroupId || filterSelectedData?.productGroupId),
      subBrandId: mergeArrays(cardDetails?.subBrand, localStorageFilter?.selectedSubBrand || filterSelectedData?.selectedSubBrand),
      colorGroupId: mergeArrays(cardDetails?.colorGroup, localStorageFilter?.selectedColorGroup || filterSelectedData?.selectedColorGroup),
      colorwayId: mergeArrays(
        cardDetails?.colorway,
        localStorageFilter?.selectedColorway || localStorageFilter?.colorwayId || filterSelectedData?.selectedColorway,
      ),
      licensorId: mergeArrays(cardDetails?.licensor, localStorageFilter?.selectedLicensor || filterSelectedData?.selectedLicensor),
      licenseId: mergeArrays(cardDetails?.license, localStorageFilter?.selectedLicense || filterSelectedData?.selectedLicense),
      likenessId: localStorageFilter?.selectedLikeness || filterSelectedData?.selectedLikeness || [],
      searchText: filterSelectedData?.searchText || '',
      timeZone,
      /*
       * The identifier tab KEY is not its api name. Sending the key reached the legacy endpoint,
       * which used to render into whichever grid was mounted; with only the v2 grid left it would
       * render every row blank on a successful response. The server aliases both names now, so
       * this is belt and braces rather than the only guard.
       */
      apiName: RPActiveTab === productIdentifier ? RP_IDENTIFIER_API_NAME : RPActiveTab,
    };
  };

  const filteredDataObj = getMergedFilterData();

  const getRPComments = async () => {
    let commentData = '';
    if (!isNoteVisible) {
      const params = {
        type: 'range-plan',
        rangeplanId,
      };
      commentData = await dispatch(ProductListAction.getNote(params));
    }
    setRangePlanProvider((prevState) => ({ ...prevState, notes: commentData?.comment }));
  };
  const initialApis = async () => {
    await Promise.all([
      dispatch(ProductListAction.getCustomAttributeFreeText()),
      dispatch(ProductListAction.fetchProductGroup(t)),
      dispatch(systemMasterAction.getSubBrandAccess()),
    ]);
  };
  useEffect(() => {
    const initializeComponent = async () => {
      try {
        await initialApis();
        await getRPComments();
        if (rangeplanId) {
          await dispatch(ProductListAction.fetchRangePlanCardDetail(rangeplanId));
        }
      } catch (error) {
        console.error('Error initializing component:', error);
      }
    };

    initializeComponent();
  }, [dispatch, rangeplanId]);

  useEffect(() => {
    const loadTemplates = async () => {
      try {
        if (!Array.isArray(costingTemplateList) || costingTemplateList.length === 0) {
          const params = { isAllRecord: true };
          await dispatch(CostingTemplateAction.getCostingTemplateList(params));
        }
      } catch (error) {
        console.error('Error loading costing templates:', error);
      }
    };
    loadTemplates();
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(ProductListAction.unmountRPInformation(t));
      dispatch(ProductListAction.clearFilterSelectedData());
      const obj = { pageIndex: 1, pageSize };
      dispatch(ProductListAction.setFilterSelection(obj));
      setRangePlanProvider((prevState) => ({
        ...prevState,
        productsList: [],
        productsNumber: 0,
      }));
      if (rangeplanId) {
        dispatch(ProductListAction.clearRangePlanCardDetail());
      }
    };
  }, []);
  useEffect(() => {
    if (customSectionsArr && !isEmpty(customSectionsArr)) {
      setLoader2(true);
      if (logInRights?.[0]?.rights?.rangePlan) {
        const array = [];
        customSectionsArr.forEach((element) => {
          logInRights.forEach((logEle) => {
            logEle?.rights?.rangePlan?.forEach((rpELe) => {
              if (rpELe?.label === `${element?.name} (Custom Section)` && rpELe?.switchstatus) {
                array.push(element);
              }
            });
          });
        });
        if (array?.length > 0) {
          setDisplayCustomSection([...array]);
        } else {
          setLoader2(false);
        }
      } else if (userInfo?.role === 'Admin') {
        setDisplayCustomSection(customSectionsArr);
      } else {
        setLoader2(false);
      }
    } else {
      setLoader2(false);
    }
  }, [customSectionsArr, logInRights, userInfo?.role]);

  useEffect(() => {
    const callFn = () => {
      if (Array.isArray(displayCustomSection) && displayCustomSection.length > 0) {
        let cloneMenuList = tabsArray.slice();
        const newCustomSection = displayCustomSection?.map((vl, i) => {
          return {
            ...vl,
            eventKey: `customSections${vl._id}`,
            eventName: vl?.name,
            index: i,
            subType: 'customsection',
          };
        });
        cloneMenuList = [...cloneMenuList, ...newCustomSection];

        setLoader2(false);
      }
    };
    if (loader2) {
      callFn();
    }
  }, [displayCustomSection, loader2]);

  useEffect(() => {
    const initializeTabsAndFetchData = async () => {
      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: true }));

      let filteredTabs = [];
      let firstActiveTab = productInfo;
      let combinedTabsArray = [...tabsArray];
      const customSectionsSource = rangePlanCardDetail?.customSections || displayCustomSection;

      if (Array.isArray(customSectionsSource) && customSectionsSource.length > 0) {
        const customSectionTabs = customSectionsSource.map((vl, i) => ({
          ...vl,
          eventKey: `customSections${vl._id}`,
          eventName: vl?.name,
          index: i,
          subType: 'customsection',
        }));
        combinedTabsArray = [...combinedTabsArray, ...customSectionTabs];
      }
      if (rangePlanCardDetail?.defaultActiveTabs && Array.isArray(rangePlanCardDetail.defaultActiveTabs)) {
        const enabledTabsWithIds = rangePlanCardDetail.defaultActiveTabs
          .filter((tab) => tab.isEnabled === true)
          .map((tab) => ({
            eventKey: cardKeyToTabEventKeyMap[tab.key],
            _id: tab._id,
            key: tab.key,
            title: tab.title,
          }))
          .filter((tab) => tab.eventKey);
        filteredTabs = combinedTabsArray
          .filter((tab) => enabledTabsWithIds.some((enabledTab) => enabledTab.eventKey === tab.eventKey))
          .map((tab) => {
            const enabledTab = enabledTabsWithIds.find((et) => et.eventKey === tab.eventKey);
            return {
              ...tab,
              _id: enabledTab?._id,
            };
          });

        if (rangePlanCardDetail?.customSections && Array.isArray(rangePlanCardDetail.customSections)) {
          const enabledCustomSections = rangePlanCardDetail.customSections.filter((section) => section.isEnabled === true);

          enabledCustomSections.forEach((enabledSection) => {
            const matchingTab = combinedTabsArray.find((tab) => tab.name === enabledSection.name && tab.eventKey && tab.eventKey.startsWith('customSections'));
            if (matchingTab && !filteredTabs.some((ft) => ft.eventKey === matchingTab.eventKey)) {
              filteredTabs.push(matchingTab);
            }
          });
        }
      } else {
        filteredTabs = combinedTabsArray;
      }
      const firstVisibleTab = filteredTabs.find(
        (tab) => (hasCostingAccess || tab.eventKey !== productCostingModuleName) && (productIdentifierTabAccess || tab.eventKey !== productIdentifier),
      );
      if (firstVisibleTab) {
        firstActiveTab = firstVisibleTab.eventKey || productInfo;
        if (firstActiveTab.includes('customSections')) {
          setSectionData(firstVisibleTab, firstVisibleTab.index);
        }
        setRangePlanProvider((prevState) => ({
          ...prevState,
          RPActiveTab: firstActiveTab,
          productsList: [],
          productsNumber: 0,
        }));

        const mergedFilters = getMergedFilterData();
        const params = {
          ...mergedFilters,
          pageIndex: 1,
          pageSize,
          apiName:
            firstActiveTab === productCostingModuleName
              ? 'product-costing'
              : firstActiveTab === 'product-info'
                ? productInfo
                : firstActiveTab === productIdentifier
                  ? RP_IDENTIFIER_API_NAME
                  : firstActiveTab,
          rangeplanId,
        };

        if (firstActiveTab === productCostingModuleName) {
          const preferred = Array.isArray(costingTemplateList) ? costingTemplateList.find((it) => it?.isDefaultTab) : null;
          const defaultTemplateId =
            selectedCostingTemplate ||
            (preferred && preferred._id) ||
            (Array.isArray(costingTemplateList) && costingTemplateList[0] && costingTemplateList[0]._id) ||
            null;
          if (defaultTemplateId) params.costingTemplateId = defaultTemplateId;
        }

        if (!subBrandRef.current) {
          delete params.subBrandId;
        }
        try {
          await dispatch(ProductListAction.fetchRPProductInfoDetails(params));
        } catch (error) {
          console.error('Error fetching product data:', error);
        }
      }
      setMenuList(filteredTabs);

      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
    };
    if (rangeplanId && rangePlanCardDetail) {
      initializeTabsAndFetchData();
    } else if (rangeplanId && !rangePlanCardDetail) {
      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: true }));
    }
  }, [rangePlanCardDetail, rangeplanId]);
  useEffect(() => {
    if (subBrandRef.current !== subBrandAccess) {
      subBrandRef.current = subBrandAccess;
    }
  }, [subBrandAccess]);

  const handleSelection = (ids) => {
    let selectIds = [...selectedIds];
    if (typeof ids === 'boolean') {
      setState((prevState) => ({
        ...prevState,
        isSelectAll: ids,
      }));
      if (!ids) selectIds = [];
      else selectIds = productsList.map((ele) => ele._id);
    } else if (ids) {
      const itemIndex = selectIds.findIndex((val) => val === ids);
      if (itemIndex >= 0) selectIds.splice(itemIndex, 1);
      else selectIds.push(ids);
      if (selectIds.length !== productsList.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: false,
        }));
      } else if (selectIds.length === productsList.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: true,
        }));
      }
    }
    setState((prev) => ({
      ...prev,
      selectedIds: selectIds,
    }));
  };

  const handleCombinationSelection = (productId, colourwayId) => {
    const selectCombinations = [...selectedCombinations];
    const combinationKey = `${productId}_${colourwayId}`;
    const itemIndex = selectCombinations.findIndex((val) => val === combinationKey);

    if (itemIndex >= 0) {
      selectCombinations.splice(itemIndex, 1);
    } else {
      selectCombinations.push(combinationKey);
    }

    setState((prev) => ({
      ...prev,
      selectedCombinations: selectCombinations,
    }));
  };

  const handleCustomSectionSelection = (ids) => {
    let selectIds = [...selectedIds];
    let isSelectAll = false;
    if (checkArray(ids)) {
      selectIds = ids;
      isSelectAll = true;
    } else {
      selectIds = [];
      isSelectAll = false;
    }
    setState((prev) => ({
      ...prev,
      selectedIds: selectIds,
      isSelectAll,
    }));
  };

  const handlePageNextInScroll = async () => {
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loadNextData: true,
    }));
    let index = pageIndex;
    index += 1;

    const mergedFilters = getMergedFilterData();
    const params = {
      pageIndex: index,
      pageSize,
      totalRecords: productsNumber,
      isScrolled: true,
      ...mergedFilters,
      timeZone,
      rangeplanId,
    };

    if (!subBrandRef.current) {
      delete params.subBrandId;
    }

    const obj = {
      pageIndex: index,
      pageSize,
    };

    await dispatch(ProductListAction.setFilterSelection(obj));
    await dispatch(ProductListAction.fetchRPProductInfoDetails(params));
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loadNextData: false,
    }));
  };
  const refreshList = useCallback(async () => {
    const mergedFilters = getMergedFilterData();
    const params = {
      pageIndex: 1,
      pageSize,
      totalRecords: productsNumber,
      ...mergedFilters,
      timeZone,
      rangeplanId,
    };

    if (!subBrandRef.current) {
      delete params.subBrandId;
    }
    dispatch(ProductListAction.setFilterSelection({ pageIndex: 1, pageSize }));
    setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: true, productsList: [], productsNumber: 0 }));
    await dispatch(ProductListAction.fetchRPProductInfoDetails(params));
    setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
  }, [pageSize, productsNumber, filteredDataObj, timeZone, dispatch, setRangePlanProvider]);

  const [searchInputValue, setSearchInputValue] = useState(filterSelectedData?.searchText || '');

  useEffect(() => {
    setSearchInputValue(filterSelectedData?.searchText || '');
  }, [filterSelectedData?.searchText]);

  const handleSearch = async (e) => {
    const inputValue = e?.target?.value ?? '';
    setSearchInputValue(inputValue);
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const trimmed = inputValue.trim();
    if (trimmed === (filterSelectedData?.searchText || '')) return;

    await dispatch(
      ProductListAction.setFilterSelection({
        searchText: trimmed,
        pageIndex: 1,
      }),
    );

    // getMergedFilterData() reads filterSelectedData from a closure that is still stale
    // until React re-renders, so the explicit `searchText: trimmed` overrides below are load-bearing.
    const mergedFilters = getMergedFilterData();

    // Custom-section tabs use a separate endpoint (/product-rangeplan/customSection)
    // and a separate redux action; mirror the param shape used by setSectionData.
    if (RPActiveTab && RPActiveTab.startsWith('customSections')) {
      const sectionId = RPActiveTab.replace('customSections', '');
      const customSectionParams = {
        sectionId,
        timeZone,
        ...mergedFilters,
        searchText: trimmed, // override stale mergedFilters.searchText — must stay AFTER spread
        rangeplanId,
        apiName: CUSTOM_SECTION_API_NAME,
        pageIndex: 1,
        pageSize: CUSTOM_SECTION_PAGE_SIZE,
      };
      if (!subBrandRef.current) {
        delete customSectionParams.subBrandId;
      }

      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: true }));
      await dispatch(ProductListAction.getCustomSectionData(customSectionParams));
      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
      return;
    }

    const params = {
      pageIndex: 1,
      pageSize,
      totalRecords: productsNumber,
      ...mergedFilters,
      searchText: trimmed, // override stale mergedFilters.searchText — must stay AFTER spread
      timeZone,
      rangeplanId,
    };
    if (!subBrandRef.current) {
      delete params.subBrandId;
    }

    setRangePlanProvider((prevState) => ({
      ...prevState,
      mainLoader: true,
      productsList: [],
      productsNumber: 0,
    }));
    await dispatch(ProductListAction.fetchRPProductInfoDetails(params));
    setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
  };

  useEffect(() => {
    const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (!loggedInUserInfo) return;

    let isMounted = true;

    const { userId } = loggedInUserInfo;
    const supplierUserId = loggedInUserInfo.supplierUserId ? loggedInUserInfo.supplierUserId : '';
    const host = window.location.hostname;
    const company = host.split('.')[0];
    const slugName = window.location.hostname?.split('.')?.[0];
    const socketURL = `${process.env.REACT_APP_PROTOCOL}${slugName}${process.env.REACT_APP_API_URL}/`;

    const socket = io(socketURL, {
      query: {
        token: loggedInUserInfo?.token,
        userId: supplierUserId !== '' ? supplierUserId : userId,
        supplierUserId,
      },
      path: '/api/socket.io',
      transports: ['websocket'],
      auth: {
        token: loggedInUserInfo?.token,
        userId: supplierUserId !== '' ? supplierUserId : userId,
        role: loggedInUserInfo?.role,
        company,
        supplierUserId,
      },
      path: '/api/socket.io',
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
    });

    /**
     * Refreshes the product list once an upload finishes processing.
     * An upload that rejects some rows still writes the rows that passed, and the callback carries
     * the error-log file in that case, so refreshing only when no file / no duplicates were reported
     * left the newly added products invisible until a manual reload. Only a hard failure, which
     * arrives as errorMsg and writes nothing, skips the refresh.
     * @param {object} data - Payload received on the lambda-callback-success channel.
     * @returns {void}
     */
    const handleLambdaCallback = (data) => {
      if (!isMounted) {
        return;
      }
      if (data?.notificationType === 'pim-download') return;

      if (data?.data?.errorMsg) {
        return;
      }

      refreshList();
    };

    socket.on('lambda-callback-success', handleLambdaCallback);

    const handleIdentifierBarcodes = () => {
      if (!isMounted) {
        return;
      }
      setState((prev) => ({ ...prev, selectedIds: [], isSelectAll: false }));
      refreshList();
    };

    socket.on('rp-identifier-barcodes-completed', handleIdentifierBarcodes);

    return () => {
      isMounted = false;
      socket.off('lambda-callback-success', handleLambdaCallback);
      socket.off('rp-identifier-barcodes-completed', handleIdentifierBarcodes);
      socket.disconnect();
    };
  }, [refreshList]);

  const handleCostingTemplateClick = async (templateId) => {
    setState((prev) => ({ ...prev, selectedCostingTemplate: templateId }));
    setCostingDataLoading(true);
    try {
      const container = document.getElementById('rpcostingtablecontainer');
      if (container && typeof container.scrollTo === 'function') {
        container.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } else if (container) {
        container.scrollTop = 0;
      }
    } catch (error) {
      console.error('Error scrolling costing table to top:', error);
    }
    const objs = {
      pageIndex: 1,
      pageSize: 20,
      timeZone,
    };
    const mergedFilters = getMergedFilterData();
    const paramsObj = {
      ...mergedFilters,
      ...objs,
      apiName: 'product-costing',
      rangeplanId,
      costingTemplateId: templateId,
    };
    if (!subBrandRef.current) {
      delete paramsObj.subBrandId;
    }
    try {
      dispatch(ProductListAction.setFilterSelection(objs));
      await dispatch(ProductListAction.fetchRPProductInfoDetails(paramsObj));
    } catch (error) {
      console.error(`Error fetching data for costing template ${templateId}:`, error);
    } finally {
      setCostingDataLoading(false);
    }
  };

  const renderTableasTab = () => {
    switch (RPActiveTab) {
      case productInfo:
        return (
          <ProductInfoTabel
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
            refreshList={refreshList}
            colouredCardFaces={colouredCardFaces}
            colouredFaces={colouredFaces}
            selectedCardAttributes={selectedCardAttributes}
            handleCombinationSelection={handleCombinationSelection}
            selectedCombinations={selectedCombinations}
          />
        );
      /*
       * BM-9586. The tab KEY stays as it is — it is persisted in localStorage and keyed on by
       * tabsArray, cardKeyToTabEventKeyMap and uploadXlsxAccessModule. It differs from the api
       * name, the download key and the workbook file type, which are named in
       * product-identifier-v2.constants.
       */
      case productIdentifier:
        return (
          <ProductIdentifierV2
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
            canEditIdentifiers={productIdentifierAddEditAccess}
          />
        );
      case productSupplier:
        return (
          <Suppliers
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
          />
        );
      case productBOM:
        return (
          <ProductBOM
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
          />
        );
      case productSpecificaion:
        return (
          <ProductSpecification
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
          />
        );
      case productTesting:
        return (
          <ProductTesting
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
          />
        );
      case careLabelInfo:
        return (
          <ProductCareLabel
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
          />
        );
      case careLabelDocument:
        return (
          <ProductCareDocument
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
          />
        );
      case productSample:
        return (
          <ProductSample
            handlePageNextInScroll={handlePageNextInScroll}
            handleSelection={handleSelection}
            selectedIds={selectedIds}
            isSelectAll={isSelectAll}
            loadNextData={loadNextData}
          />
        );
      case productCostingModuleName:
        return (
          <>
            <div className="d-flex align-items-center mb-8">
              <ProductCostingTabMenu
                masterActiveTab={selectedCostingTemplate}
                MenuList={costingTemplateListOptions}
                isAPILoading={costingDataLoading}
                activeTheTab={handleCostingTemplateClick}
              />
            </div>
            <ProductCostingTable
              activeCostingTemplate={selectedCostingTemplate}
              rangeplanId={rangeplanId}
              handleSelection={handleSelection}
              selectedIds={selectedIds}
              isSelectAll={isSelectAll}
              loadNextData={loadNextData}
              isCostingDataLoading={costingDataLoading}
              getSelectedIdsWithDevIds={(arr) => {
                const list = arr ?? [];
                const devIds = list.map((x) => (typeof x?.devOrderId === 'string' ? x.devOrderId : x?.devOrderId?.toString?.() ?? '')).filter(Boolean);
                const costingIds = list.map((x) => (typeof x?.costingId === 'string' ? x.costingId : x?.costingId?.toString?.() ?? '')).filter(Boolean);
                setState((prev) => ({ ...prev, selectedIds: devIds, selectedCostingIds: costingIds }));
              }}
            />
          </>
        );
      default:
        if (RPActiveTab && RPActiveTab.startsWith('customSections')) {
          const sectionId = RPActiveTab.replace('customSections', '');
          const customSectionsSource = rangePlanCardDetail?.customSections || displayCustomSection;
          const currentSection = customSectionsSource?.find((section) => section._id === sectionId);
          if (currentSection) {
            return (
              <ProductInfoCustomSections
                filteredDataObj={filteredDataObj}
                section={currentSection}
                handleSelection={handleSelection}
                selectedIds={selectedIds}
                isSelectAll={isSelectAll}
                handleCustomSectionSelection={handleCustomSectionSelection}
                refreshList={refreshList}
                colouredCardFaces={colouredCardFaces}
                colouredFaces={colouredFaces}
                selectedCardAttributes={selectedCardAttributes}
                handleCombinationSelection={handleCombinationSelection}
                selectedCombinations={selectedCombinations}
              />
            );
          }
        }
        break;
    }
  };

  const setSectionData = async (section, activeIndex) => {
    setState((prev) => ({
      ...prev,
      activeCustomIndex: activeIndex,
      activeCustomSectiondata: section,
    }));

    setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: true }));

    try {
      const allSectionColumnsParams = {
        rangeplanId,
        sectionId: section?._id,
        timeZone,
      };

      await dispatch(ProductListAction.getAllSectionColumns(allSectionColumnsParams));
    } catch (error) {
      console.error('Error fetching section columns:', error);
    }

    const mergedFilters = getMergedFilterData();

    const customSectionParams = {
      sectionId: section?._id,
      timeZone,
      ...mergedFilters,
      rangeplanId,
      apiName: CUSTOM_SECTION_API_NAME,
      pageIndex: 1,
      pageSize: CUSTOM_SECTION_PAGE_SIZE,
    };

    if (!subBrandRef.current) {
      delete customSectionParams.subBrandId;
    }

    if (rangeplanId && section?._id) {
      try {
        const res = await dispatch(ProductListAction.getCustomSectionData(customSectionParams));
        if (res?.code === 200) {
          if (res?.data) {
            setRangePlanProvider((prevState) => ({
              ...prevState,
              mainLoader: false,
            }));
          } else {
            setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
          }
        } else {
          setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
        }
      } catch (error) {
        setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
      }
    } else {
      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
    }
  };

  const activeTheTab = async (tabName) => {
    setState((prev) => ({
      ...prev,
      selectedIds: [],
      isSelectAll: false,
      selectedCostingIds: [],
      selectedCombinations: [],
    }));

    setRangePlanProvider((prevState) => ({
      ...prevState,
      RPActiveTab: tabName,
      productsList: [],
      mainLoader: true,
    }));
    try {
      const scrollContainers = document.querySelectorAll('.rp-scroll-container');
      scrollContainers.forEach((el) => {
        if (el && typeof el.scrollTo === 'function') {
          el.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        } else if (el) {
          el.scrollTop = 0;
        }
      });
    } catch (error) {
      console.error('Error scrolling to top in activeTheTab:', error);
    }

    const objs = {
      pageIndex: 1,
      pageSize: 20,
      timeZone,
    };

    const mergedFilters = getMergedFilterData();

    const getApiName = (tabName) => {
      switch (tabName) {
        case productInfo:
          return 'product-info';
        case productIdentifier:
          /* Swaps the backend on its own: the service appends apiName to the rp-info URL. */
          return RP_IDENTIFIER_API_NAME;
        case productSupplier:
          return 'supplier-info';
        case productBOM:
          return 'bom-info';
        case productSpecificaion:
          return 'specification';
        case productTesting:
          return 'productTesting';
        case careLabelInfo:
          return 'care-label-info';
        case careLabelDocument:
          return 'care-label-document';
        case productSample:
          return 'samples';
        case productCostingModuleName:
          return 'product-costing';
        default:
          return tabName;
      }
    };

    if (!tabName?.includes('customSections')) {
      const paramsObj = {
        ...mergedFilters,
        ...objs,
        apiName: getApiName(tabName),
        rangeplanId,
      };

      if (tabName === productCostingModuleName) {
        const defaultTemplate = Array.isArray(costingTemplateList) ? costingTemplateList.find((it) => it?.isDefaultTab) : null;
        const templateIdToUse =
          selectedCostingTemplate ||
          (defaultTemplate && defaultTemplate._id) ||
          (Array.isArray(costingTemplateList) && costingTemplateList[0] && costingTemplateList[0]._id) ||
          null;
        if (templateIdToUse) paramsObj.costingTemplateId = templateIdToUse;
      }

      if (!subBrandRef.current) {
        delete paramsObj.subBrandId;
      }

      if (tabName === productInfo) {
        const raw = localStorageFilter || {};
        const resolvedColorway = !isEmpty(raw?.selectedColorway) ? raw.selectedColorway : raw?.colorwayId;
        const normalizedColorway = Array.isArray(resolvedColorway) ? resolvedColorway : resolvedColorway ? [resolvedColorway] : [];
        dispatch(
          ProductListAction.setFilterSelection({
            ...raw,
            ...(normalizedColorway.length ? { selectedColorway: normalizedColorway } : {}),
            pageIndex: 1,
            pageSize: 20,
          }),
        );
      } else {
        dispatch(ProductListAction.setFilterSelection(objs));
      }
      if (tabName === productCostingModuleName) {
        setCostingDataLoading(true);
      }

      try {
        await dispatch(ProductListAction.fetchRPProductInfoDetails(paramsObj));

        if (tabName === productSample) {
          dispatch(ProductListAction.getSampleTrackingDetails());
        }
        if (tabName === productSpecificaion) {
          dispatch(ProductListAction.getSystemMeasurement());
        }
      } catch (error) {
        console.error(`Error fetching data for tab ${tabName}:`, error);
      }

      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
      if (tabName === productCostingModuleName) {
        setCostingDataLoading(false);
      }
      setTimeout(() => {
        try {
          const scrollContainers = document.querySelectorAll('.rp-scroll-container');
          scrollContainers.forEach((el) => {
            if (el && typeof el.scrollTo === 'function') {
              el.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            } else if (el) {
              el.scrollTop = 0;
            }
          });
        } catch (error) {
          console.error('Error scrolling to top:', error);
        }
      }, 0);
    }
  };

  const navigateLog = () => {
    history.push({
      pathname: '/range-plan/logs',
      state: { from: location.pathname },
    });
  };

  const showHideNote = async () => {
    setRangePlanProvider((prevState) => ({ ...prevState, isNoteVisible: !isNoteVisible }));
  };

  const handleChangeComment = (commentData) => {
    setRangePlanProvider((prev) => ({
      ...prev,
      notes: commentData,
    }));
  };
  const autoSaveNote = async (text) => {
    const params = {
      type: 'range-plan',
    };
    const payload = {
      comment: text,
      isVisibleToSupplier: {
        comment: false,
      },
      rangeplanId,
    };
    await dispatch(ProductListAction.saveNote(params, payload, t));
  };
  const openCloseExchangeModal = async () => {
    setState((prev) => ({
      ...prev,
      exchangeRateModal: !prev.exchangeRateModal,
    }));
    setRangePlanProvider((prevState) => ({
      ...prevState,
      selectedSection: null,
      manualList: [],
    }));
  };
  const onChangeExchangeValue = (e) => {
    setState((prev) => ({
      ...prev,
      exchangeRate: e,
    }));
  };
  const hadleSumbitExchange = async (e) => {
    e.preventDefault();
    if (!exchangeRate) {
      setState((prev) => ({
        ...prev,
        errors: true,
      }));
      return;
    }
    setState((prev) => ({
      ...prev,
      exchangeLoader: true,
    }));
    const obj = {
      devOrderIds: selectedIds,
      exchangeRate,
      type: 'costing',
    };
    const res = await dispatch(ProductListAction.bulkExchangeRateUpdate(obj, t));
    if (res) {
      setState((prev) => ({
        ...prev,
        exchangeLoader: false,
        exchangeRateModal: false,
        exchangeRate: '',
        errors: false,
      }));
      setRangePlanProvider((prevState) => ({
        ...prevState,
        selectedSection: null,
      }));
    }
  };
  const openCloseManualModal = async () => {
    setState((prev) => ({
      ...prev,
      isManualModal: !prev.isManualModal,
    }));
    setRangePlanProvider((prevState) => ({
      ...prevState,
      selectedSection: null,
      manualList: [],
    }));
  };
  const openCloseProductFieldlModal = async () => {
    setState((prev) => ({
      ...prev,
      isProductFieldModal: !prev.isProductFieldModal,
    }));
    setRangePlanProvider((prevState) => ({
      ...prevState,
      selectedSection: null,
      productFields: [],
    }));
  };

  const downloadExcelSheet = async (downloadType) => {
    const hasSelection = isArray(selectedIds) && selectedIds.length > 0;
    const isDownloadSelected = downloadType === 'selected';
    if (isDownloadSelected && !hasSelection) return;

    const activeTab = [];
    switch (RPActiveTab) {
      case productInfo:
        activeTab.push('productInfo');
        break;
      case productIdentifier:
        activeTab.push(RP_IDENTIFIER_DOWNLOAD_KEY);
        break;
      case 'supplier-info':
        activeTab.push('productSupplier');
        break;
      case productBOM:
        activeTab.push('productBOM');
        break;
      case productSpecificaion:
        activeTab.push('specification');
        break;
      case productTesting:
        activeTab.push('productTesting');
        break;
      case careLabelInfo:
        activeTab.push('careLabelInfo');
        break;
      case careLabelDocument:
        activeTab.push('careLabelDocument');
        break;
      case productSample:
        activeTab.push('sampleInfo');
        break;
      case productCostingModuleName:
        activeTab.push('costingInfo');
        break;
      default:
        activeTab.push(RPActiveTab);
        break;
    }

    const reqObj = {
      timeZone,
      selectedInfo: activeTab,
      rangeplanId,
    };
    if (RPActiveTab === productCostingModuleName) {
      reqObj.tabId = 'costing';
      const defaultTemplate = Array.isArray(costingTemplateList) ? costingTemplateList.find((it) => it?.isDefaultTab) : null;
      reqObj.costingTemplateId =
        selectedCostingTemplate || (defaultTemplate && defaultTemplate._id) || (Array.isArray(costingTemplateList) && costingTemplateList[0]?._id) || null;
    }

    if (isDownloadSelected && hasSelection) {
      reqObj.devOrderIds = selectedIds;
      reqObj.excludeProductImage = excludeProductImage;
      setState((prev) => ({ ...prev, downloadLoading: true }));
      try {
        if (RPActiveTab === productCostingModuleName) {
          let costingIdsToUse = selectedCostingIds;
          if (!isArray(costingIdsToUse) || costingIdsToUse.length === 0) {
            const doc = Array.isArray(rangePlanProductInfo?.data?.doc)
              ? rangePlanProductInfo.data.doc
              : Array.isArray(reduxCostingListData)
              ? reduxCostingListData
              : [];
            const selectedRowIds = Array.isArray(reduxCostingSelectedIds) ? reduxCostingSelectedIds : [];
            if (doc.length > 0 && selectedRowIds.length > 0) {
              const selectedRows = doc.filter((row) => row?._id != null && selectedRowIds.some((sid) => String(sid) === String(row._id)));
              costingIdsToUse = selectedRows.flatMap((row) => {
                const initialId = row?.initialData?._id;
                const expandIds = Array.isArray(row?.expandData) ? row.expandData.map((e) => e?._id).filter(Boolean) : [];
                return [initialId, ...expandIds].filter(Boolean).map((id) => (typeof id === 'string' ? id : id?.toString?.()));
              });
            }
          }
          if (isArray(costingIdsToUse) && costingIdsToUse.length > 0) {
            reqObj.costingIds = costingIdsToUse;
          }
          await dispatch(ProductListAction.downloadCostingExportSelected(reqObj, t));
        } else {
          await dispatch(ProductListAction.downloadRanplanExcelSheet(reqObj, t));
        }
      } finally {
        setState((prev) => ({ ...prev, downloadLoading: false }));
      }
    } else {
      reqObj.filterObj = filteredDataObj;
      reqObj.excludeProductImage = excludeProductImage;
      if (RPActiveTab === productCostingModuleName) {
        reqObj.searchText = costingFilterValues?.searchText ?? '';
      }
      setState((prev) => ({ ...prev, downloadLoading: true }));
      try {
        if (RPActiveTab === productCostingModuleName) {
          await dispatch(ProductListAction.downloadCostingExportAll(reqObj, t));
        } else {
          await dispatch(ProductListAction.downloadRanplanExcelSheet(reqObj, t));
        }
      } finally {
        setState((prev) => ({ ...prev, downloadLoading: false }));
      }
    }
  };

  const downloadPPT = async (type) => {
    setState((prev) => ({ ...prev, downloadLoading: true }));

    const reqObj = {
      timeZone,
      selectedInfo: ['productInfo'],
      rangeplanId,
      downloadType: 'ppt',
      selectedCardAttributes: selectedCardAttributes?.map((attr) => attr.value),
      colouredFaces,
    };

    if (type === 'selected') {
      if (colouredFaces && isArray(selectedCombinations) && selectedCombinations.length > 0) {
        const groupedSelections = selectedCombinations.reduce((acc, combination) => {
          const [productId, colourwayId] = combination.split('_');
          const existing = acc.find((item) => item.productId === productId);
          if (existing) {
            existing.colourwayIds.push(colourwayId);
          } else {
            acc.push({ productId, colourwayIds: [colourwayId] });
          }
          return acc;
        }, []);
        reqObj.colouredCombinationSelections = groupedSelections;
        reqObj.devOrderIds = groupedSelections?.map((combination) => combination?.productId);
      } else if (isArray(selectedIds) && selectedIds.length > 0) {
        reqObj.devOrderIds = selectedIds;
      }
    } else {
      reqObj.filterObj = filteredDataObj;
      if (colouredFaces) {
        reqObj.isAllDownloadForCombination = true;
      }
    }

    reqObj.excludeProductImage = excludeProductImage;

    await dispatch(ProductListAction.downloadRanplanExcelSheet(reqObj, t));
    setState((prev) => ({ ...prev, downloadLoading: false }));
  };

  /*
   * Hoisted out of `handleDownload`, where it was declared as a local const while
   * `handleDownloadPPT` below also reads it — an unreachable ReferenceError today, because nothing
   * calls that function, but a live one the moment anything does.
   */
  const sheetNames = {
    'product-info': 'Product Information',
    'product-identifier': 'Product Identifier',
  };

  const handleDownload = async (type) => {
    if (type === 'All') {
      setState((prev) => ({ ...prev, downloadLoading: true }));
      const data = { type: 'all', sheetName: sheetNames[RPActiveTab] };
      await dispatch(ProductListAction.downloadRPSheets(data, t));
      setState((prev) => ({ ...prev, downloadLoading: false }));
    } else if (type === 'Sample') {
      setState((prev) => ({ ...prev, downloadLoading: true }));
      const data = {
        type: 'sample',
        sheetName: sheetNames[RPActiveTab],
      };
      await dispatch(ProductListAction.downloadRPSheets(data, t));
      setState((prev) => ({ ...prev, downloadLoading: false }));
    } else if (type === 'selected') {
      setState((prev) => ({ ...prev, downloadLoading: true }));
      const data = {
        selectedIds: state?.selectedIds,
        type: 'selected',
        sheetName: sheetNames[RPActiveTab],
      };
      await dispatch(ProductListAction.downloadRPSheets(data, t));
      setState((prev) => ({ ...prev, downloadLoading: false }));
    }
  };

  const handleDownloadPPT = async (type) => {
    const data = {
      type,
      sheetName: sheetNames[RPActiveTab],
    };
    await dispatch(ProductListAction.downloadRPSheets(data, t));
  };

  const rendeDownloadPopover = () => {
    switch (RPActiveTab) {
      case productInfo:
        return (
          <ul>
            <li>
              <button className="p-0 btn" type="button" onClick={() => handleDownload('Sample')} disabled={downloadLoading}>
                {downloadLoading ? t(downloading) : t('COLOUR_LIBRARY.DOWNLOAD_SAMPLE_FILE')}
              </button>
            </li>
            <li>
              <button
                className="p-0 btn"
                type="button"
                disabled={isEmpty(state?.selectedIds) || downloadLoading}
                onClick={() => downloadExcelSheet('selected')}
              >
                {downloadLoading ? t(downloading) : t('COLOUR_LIBRARY.DOWNLOAD_SELECTED_DATA')}
              </button>
            </li>
            <li>
              <button
                type="button"
                disabled={!productsList?.length || downloadLoading}
                onClick={() => downloadExcelSheet('all')}
                className={downloadLoading ? ' disabled-btn p-0 btn' : ' p-0 btn'}
              >
                {downloadLoading ? t(downloading) : t('COLOUR_LIBRARY.DOWNLOAD_ALL_DATA')}
              </button>
            </li>
          </ul>
        );
      case productIdentifier:
      case productSupplier:
      case productBOM:
      case productSpecificaion:
      case productTesting:
      case careLabelInfo:
      case careLabelDocument:
      case productSample:
      case productCostingModuleName:
        return (
          <ul>
            <li>
              <button className="p-0 btn" type="button" disabled={isEmpty(selectedIds) || downloadLoading} onClick={() => downloadExcelSheet('selected')}>
                {downloadLoading ? t(downloading) : t('COLOUR_LIBRARY.DOWNLOAD_SELECTED_DATA')}
              </button>
            </li>
            <li>
              <button
                type="button"
                disabled={!(productsList?.length || productsNumber) || downloadLoading}
                onClick={() => downloadExcelSheet('all')}
                className={downloadLoading ? ' disabled-btn p-0 btn' : ' p-0 btn'}
              >
                {downloadLoading ? t(downloading) : t('COLOUR_LIBRARY.DOWNLOAD_ALL_DATA')}
              </button>
            </li>
          </ul>
        );
      default:
        return (
          <ul>
            <li>
              <button className="p-0 btn" type="button" disabled={isEmpty(selectedIds) || downloadLoading} onClick={() => downloadExcelSheet('selected')}>
                {downloadLoading ? t(downloading) : t('COLOUR_LIBRARY.DOWNLOAD_SELECTED_DATA')}
              </button>
            </li>
            <li>
              <button
                type="button"
                disabled={!customSectionData?.data?.length || downloadLoading}
                onClick={() => downloadExcelSheet('all')}
                className={downloadLoading ? ' disabled-btn p-0 btn' : ' p-0 btn'}
              >
                {downloadLoading ? t(downloading) : t('COLOUR_LIBRARY.DOWNLOAD_ALL_DATA')}
              </button>
            </li>
          </ul>
        );
    }
  };

  const renderDownloadOptionColouredCardFaces = () => {
    const hasSelections = colouredFaces ? !isEmpty(selectedCombinations) : !isEmpty(selectedIds);

    switch (RPActiveTab) {
      case productInfo:
        return (
          <ul>
            <li>
              <button className="p-0 btn" type="button" disabled={!hasSelections || downloadLoading} onClick={() => downloadPPT('selected')}>
                {downloadLoading ? t(downloading) : 'Download Selected as Power Point'}
              </button>
            </li>
            <li>
              <button className="p-0 btn" type="button" disabled={!productsList?.length || downloadLoading} onClick={() => downloadPPT('all')}>
                {downloadLoading ? t(downloading) : 'Download All as Power Point'}
              </button>
            </li>
          </ul>
        );
      default:
        return null;
    }
  };
  const getNoteClass = () => {
    if (notes !== '') {
      return 'btn active btn-amber-dot';
    }
    if (isNoteVisible) {
      return 'btn active';
    }
    return 'btn';
  };

  const uploadXlsx = () => {
    setState((prevState) => ({
      ...prevState,
      showUploadModal: true,
    }));
  };

  const closeUploadModal = () => {
    setState((prevState) => ({
      ...prevState,
      showUploadModal: false,
      importLoading: false,
      filesSelected: null,
      showErrModal: false,
      totalRecordsToUpload: 0,
      errorRecordCount: 0,
      successRecordCount: 0,
      errFile: '',
    }));
  };

  const checkValidFile = (file, context) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        const workbook = XLSX.read(new Uint8Array(e.target.result), { type: 'array' });
        const metadataString = workbook.Sheets?.Metadata?.A1?.v;
        if (!metadataString) return resolve({ valid: false });

        try {
          const metadata = JSON.parse(metadataString);
          let expectedKey = null;
          if (RPActiveTab === productInfo) {
            expectedKey = 'product_information';
          } else if (RPActiveTab === productIdentifier) {
            /*
             * Flag-derived, which makes the guard symmetric for free: a v1 sheet is rejected while
             * the flag is on, and a v2 sheet while it is off. The two writers read different size
             * vocabularies, so neither can safely accept the other's workbook.
             */
            expectedKey = RP_IDENTIFIER_FILE_TYPE;
          } else if (RPActiveTab === productBOM) {
            expectedKey = 'BOM_Information';
          } else if (RPActiveTab === productTesting) {
            expectedKey = 'testing_infomation';
          } else if (RPActiveTab && RPActiveTab.startsWith('customSections')) {
            expectedKey = 'custom_section';
          }
          const fileTypeMatch = expectedKey ? metadata.fileType === expectedKey : false;
          if (!fileTypeMatch) return resolve({ valid: false });
          if (expectedKey === 'custom_section' && context?.sectionId != null) {
            const sheetSectionId = metadata.sectionId ?? '';
            if (sheetSectionId && sheetSectionId !== context.sectionId) {
              return resolve({ valid: false, notAssociated: true });
            }
          }
          return resolve({ valid: true });
        } catch {
          return resolve({ valid: false });
        }
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const handleFile = async () => {
    if (docRef?.current) {
      const uploadedDoc = await docRef.current.selectedDocument();

      if (!uploadedDoc) return;

      const _rawSectionId = RPActiveTab && RPActiveTab.startsWith('customSections') ? RPActiveTab.split('customSections')[1] : '';
      const customSectionContext = _rawSectionId && rangeplanId ? { sectionId: _rawSectionId, rangeplanId } : undefined;
      if (![careLabelInfo, productTesting].includes(RPActiveTab)) {
        const validation = await checkValidFile(uploadedDoc.document, customSectionContext);
        if (!validation.valid) {
          toasterMsg(validation.notAssociated ? t('RANGE_PLANS.SHEET_NOT_ASSOCIATED') : t('RANGE_PLANS.INVALID_FILE'), 'danger');
          return;
        }
      }

      const binary = uploadedDoc.document;
      binary.fileName = binary.name;

      setState((prev) => ({ ...prev, filesSelected: binary, importLoading: true, loading: true }));

      if (binary.size > 26214400) {
        toasterMsg(t('RANGE_PLANS.FILE_ERROR'), 'danger');
        return;
      }

      const params = {
        xls: binary,
        activeTab: RPActiveTab,
      };

      if (RPActiveTab && RPActiveTab.startsWith('customSections') && _rawSectionId) {
        const sectionId = _rawSectionId;
        toasterMsg(t('RANGE_PLANS.RANGEPLAN_SHEET_UPLOAD_IN_PROGRESS'), 'success');
        const customSectionResponse = await dispatch(ProductListAction.uploadRPCustomSectionFileToS3(binary, RPActiveTab, sectionId, rangeplanId));
        if (customSectionResponse?.success) {
          setState((prev) => ({ ...prev, importLoading: false, filesSelected: null }));
          toasterMsg(customSectionResponse?.message, 'success');
        } else {
          toasterMsg(customSectionResponse?.message || t('RANGE_PLANS.INVALID_FILE'), 'danger');
        }
        closeUploadModal();
        return;
      }
      const directS3UploadByTab = {
        [careLabelInfo]: {
          keyPrefix: 'uploads/care/care-user-import',
          sessionIdPrefix: 'care',
          register: registerCareUpload,
        },
        [productTesting]: {
          keyPrefix: 'uploads/testing/testing-import',
          sessionIdPrefix: 'testing',
          register: registerTestingUpload,
        },
      };
      const directUpload = directS3UploadByTab[RPActiveTab];
      if (directUpload) {
        try {
          const timestamp = Date.now();
          const s3Key = `${directUpload.keyPrefix}-${timestamp}.xlsx`;
          const uploadSocketId = getCurrentSocketId();
          const uploadSessionId = window.crypto?.randomUUID
            ? window.crypto.randomUUID()
            : `${directUpload.sessionIdPrefix}-${timestamp}-${Math.random().toString(36).slice(2, 10)}`;
          directUpload.register(uploadSessionId);

          const preSignedResponse = await getPreWriteSignedWriteUrl({
            objectKey: s3Key,
            expiresInSeconds: 3600,
            section: 'IMPORT-EXCEL',
            ...(uploadSocketId ? { uploadSocketId } : {}),
            uploadSessionId,
          });
          const presignedUrl = preSignedResponse?.data;
          if (!presignedUrl) {
            toasterMsg(t('RANGE_PLANS.INVALID_FILE'), 'danger');
            setState((prev) => ({ ...prev, importLoading: false, filesSelected: null, loading: false }));
            return;
          }

          const uploadResponse = await ProductListService.uploadFileToS3Direct(presignedUrl, binary);
          if (!uploadResponse?.success) {
            toasterMsg(uploadResponse?.error || t('RANGE_PLANS.INVALID_FILE'), 'danger');
            setState((prev) => ({ ...prev, importLoading: false, filesSelected: null, loading: false }));
            return;
          }

          toasterMsg(t('RANGE_PLANS.RANGEPLAN_SHEET_UPLOAD_IN_PROGRESS'), 'success');
        } catch (error) {
          toasterMsg(t('RANGE_PLANS.INVALID_FILE'), 'danger');
        } finally {
          setState((prev) => ({ ...prev, importLoading: false, filesSelected: null, loading: false }));
          closeUploadModal();
        }
        return;
      }

      switch (RPActiveTab) {
        case productInfo:
          const resProductInfo = await dispatch(ProductListAction.importProductsInSystem(params, t));
          if (resProductInfo?.code === 200) {
            setRangePlanProvider((prevState) => ({
              ...prevState,
              productsList: [],
              productsNumber: 0,
            }));
            setState((prev) => ({ ...prev, importLoading: false, filesSelected: null }));
            const mergedFilters = getMergedFilterData();
            const fetchParams = {
              pageIndex: 1,
              pageSize,
              apiName: productInfo,
              ...mergedFilters,
              rangeplanId,
            };
            if (!subBrandRef.current) {
              delete fetchParams.subBrandId;
            }
            const obj = { pageIndex: 1, pageSize };

            await dispatch(ProductListAction.setFilterSelection(obj));
            await dispatch(ProductListAction.fetchRPProductInfoDetails(fetchParams));

            if (resProductInfo?.data?.logErr?.length > 0) {
              setState((prev) => ({
                ...prev,
                showErrModal: true,
                totalRecordsToUpload: resProductInfo?.data?.totalCount,
                errorRecordCount: resProductInfo?.data?.errorDataCount,
                successRecordCount: resProductInfo?.data?.successDataCount,
                errFile: resProductInfo?.data?.file,
              }));
            }
          }
          break;

        case productIdentifier:
          /*
           * The server switches on `moduleExcelType`, so the v2 writer is reached by sending the
           * v2 api name rather than the shared tab key. `params` is otherwise untouched.
           */
          const piResponse = await dispatch(
            ProductListAction.importProductIdentifierInSystem(
              { ...params, activeTab: RP_IDENTIFIER_API_NAME },
              t
            )
          );
          if (piResponse?.code === 200) {
            setRangePlanProvider((prevState) => ({
              ...prevState,
              productsList: [],
              productsNumber: 0,
            }));
            setState((prev) => ({ ...prev, filesSelected: null }));
            const mergedFilters = getMergedFilterData();
            const fetchParams = {
              pageIndex: 1,
              pageSize,
              ...mergedFilters,
              /*
               * AFTER the filter spread, never before: `getMergedFilterData` carries the shared
               * TAB key as `apiName`, so spreading it later silently swapped this back to the v1
               * endpoint. The grid then repopulated from the legacy path, whose response has no
               * v2 view — every row rendered blank and a successful upload read as data loss.
               */
              apiName: RP_IDENTIFIER_API_NAME,
              rangeplanId,
            };

            if (!subBrandRef.current) {
              delete fetchParams.subBrandId;
            }
            const obj = { pageIndex: 1, pageSize };
            await dispatch(ProductListAction.setFilterSelection(obj));

            await dispatch(ProductListAction.fetchRPProductInfoDetails(fetchParams));

            if (piResponse?.data?.logErr?.length > 0) {
              /*
               * The v2 outcome names its counts differently from the legacy importers, and the
               * error file arrives base64 on the response rather than as a server path — kept in
               * state so the modal's download button can hand it over on an explicit click, which
               * the browser always honours even when it held back the automatic save.
               *
               * This close is inlined and the case RETURNS: the shared `closeUploadModal()` after
               * the switch resets `showErrModal` to false, so letting it run would blank the modal
               * in the same breath it was opened and the user would never see their rejections.
               */
              const outcome = piResponse.data;
              const rowsWithErrors = outcome.rejected + (outcome.rowsWithCellErrors ?? 0);
              setState((prev) => ({
                ...prev,
                showUploadModal: false,
                importLoading: false,
                filesSelected: null,
                showErrModal: true,
                totalCount: outcome.processed,
                successCount: outcome.processed - rowsWithErrors,
                errorCount: rowsWithErrors,
                errFile: null,
                identifierErrorSheet: outcome.errorSheet ?? null,
              }));
              return;
            }
          }
          break;
        case productBOM:
          {
            params.apiName = productBOM;
            const bomResponse = await dispatch(ProductListAction.importProductIdentifierInSystem(params, t));
            if (bomResponse?.code === 200) {
              setRangePlanProvider((prevState) => ({
                ...prevState,
                productsList: [],
                productsNumber: 0,
              }));
              setState((prev) => ({ ...prev, importLoading: false, filesSelected: null }));
              const mergedFilters = getMergedFilterData();
              const fetchParams = {
                pageIndex: 1,
                pageSize,
                apiName: productBOM,
                ...mergedFilters,
                rangeplanId,
              };
              if (!subBrandRef.current) {
                delete fetchParams.subBrandId;
              }
              const obj = { pageIndex: 1, pageSize };
              await dispatch(ProductListAction.setFilterSelection(obj));
              await dispatch(ProductListAction.fetchRPProductInfoDetails(fetchParams));
              if (bomResponse?.data?.logErr?.length > 0) {
                setState((prev) => ({
                  ...prev,
                  showErrModal: true,
                  totalRecordsToUpload: bomResponse?.data?.totalCount,
                  errorRecordCount: bomResponse?.data?.errorDataCount,
                  successRecordCount: bomResponse?.data?.successDataCount,
                  errFile: bomResponse?.data?.file,
                }));
              }
            }
          }
          break;
        case productTesting:
          {
            params.apiName = productTesting;
            const testingResponse = await dispatch(ProductListAction.importProductIdentifierInSystem(params, t));
            if (testingResponse?.code === 200) {
              setRangePlanProvider((prevState) => ({
                ...prevState,
                productsList: [],
                productsNumber: 0,
              }));
              setState((prev) => ({ ...prev, importLoading: false, filesSelected: null }));
              const mergedFilters = getMergedFilterData();
              const fetchParams = {
                pageIndex: 1,
                pageSize,
                apiName: productTesting,
                ...mergedFilters,
                rangeplanId,
              };
              if (!subBrandRef.current) {
                delete fetchParams.subBrandId;
              }
              const obj = { pageIndex: 1, pageSize };
              await dispatch(ProductListAction.setFilterSelection(obj));
              await dispatch(ProductListAction.fetchRPProductInfoDetails(fetchParams));
              if (testingResponse?.data?.logErr?.length > 0) {
                setState((prev) => ({
                  ...prev,
                  showErrModal: true,
                  totalRecordsToUpload: testingResponse?.data?.totalCount,
                  errorRecordCount: testingResponse?.data?.errorDataCount,
                  successRecordCount: testingResponse?.data?.successDataCount,
                  errFile: testingResponse?.data?.file,
                }));
              }
            }
          }
          break;
        case 'supplier-info':
          params.apiName = 'product-supplier';
          break;

        default:
          break;
      }

      closeUploadModal();
    }
  };

  const toggleErr = () => {
    setState((prev) => ({ ...prev, showErrModal: false }));
  };
  const handleErrorDownload = async () => {
    /*
     * The v2 identifier import returns its error sheet base64 on the response instead of writing
     * a server file, so this click saves it directly. A click-driven save also matters on its own:
     * the automatic save fires right after the upload, and a browser can hold that one back for
     * confirmation — this button is the path that always lands.
     */
    if (state?.identifierErrorSheet) {
      ProductListAction.saveProductIdentifierErrorSheet({ errorSheet: state.identifierErrorSheet });
      toggleErr();
      return;
    }
    /*
     * Everything else is a file the server wrote. Three shapes reach here: an absolute URL, a
     * path on this origin, and an S3 object key — the last needs a presigned URL before it can
     * be fetched at all, which is why this is async.
     */
    const errFile = state?.errFile;
    if (!errFile) return;
    let href;
    if (errFile.startsWith('http')) {
      href = errFile;
    } else if (errFile.startsWith('/')) {
      href = `${window.location.origin}${errFile}`;
    } else {
      const res = await getPreReadSignedWriteUrl({ objectKey: errFile });
      if (res?.code !== 200 || !res?.data) return;
      href = res.data;
    }
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', errFile.split('/').pop() || errFile);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toggleErr();
  };

  const rangePlanDuplicateConfirmLock = useRef(false);
  const [isConfirmingRangePlanDuplicates, setIsConfirmingRangePlanDuplicates] = useState(false);

  useEffect(() => {
    if (productIdentifierTabAccess || RPActiveTab !== RP_IDENTIFIER_TAB_KEY || menuList.length === 0) return;
    // Rights can be withdrawn live (user-rights socket); leave the identifier tab for the first one still shown.
    const nextTab = menuList.find(
      (tab) => tab.eventKey !== RP_IDENTIFIER_TAB_KEY && (hasCostingAccess || tab.eventKey !== productCostingModuleName),
    );
    if (!nextTab) return;
    if (nextTab.subType === 'customsection') setSectionData(nextTab, nextTab.index);
    activeTheTab(nextTab.eventKey);
  }, [productIdentifierTabAccess, RPActiveTab, menuList]);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">
            {t('RANGE_PLANS.PRODUCT_LIST.PAGE_TITLE_FILTER')} | {rangePlanCardDetail?.name}
          </h4>
          {colouredCardFaces && (
            <>
              {colouredFaces ? (
                <button type="button" className="btn" aria-label="Download" onClick={() => setState((prev) => ({ ...prev, colouredFaces: false }))}>
                  <img src={iconColoured} alt="Black and White" />
                </button>
              ) : (
                <button type="button" className="btn" aria-label="Download" onClick={() => setState((prev) => ({ ...prev, colouredFaces: true }))}>
                  <img src={iconBlackWhite} alt="Coloured" />
                </button>
              )}
            </>
          )}
        </div>
        <div className="search-filter action-new-row">
          <div className="action-icons-container">
            {/* Card Attributes Selector - Only show for card view */}
            {colouredCardFaces && (
              <div className="card-attributes-selector me-3">
                <MultiSelect
                  options={getGroupedCardAttributes()}
                  value={selectedCardAttributes}
                  onChange={handleCardAttributeChange}
                  labelledBy={t('RANGE_PLANS.PRODUCT_LIST.SELECT_CARD_ATTRIBUTES')}
                  className="bordered-multiselect common-new-multiselect w-250px"
                  hasSelectAll={false}
                />
              </div>
            )}
            <SearchBarNew value={searchInputValue} placeholder={t('RANGE_PLANS.PRODUCT_LIST.SEARCH_PLACEHOLDER')} onSearch={handleSearch} />
            <FilterProductList activeCustomSectiondata={activeCustomSectiondata} costingTemplateId={selectedCostingTemplate} />
            <button
              type="button"
              className="btn p-0 d-inline-flex"
              onClick={() => {
                if (isCardView) {
                  history.push(`/rangeplan/product-list/${rangeplanId}`);
                } else {
                  history.push('/rangeplan/card-view');
                }
              }}
              title="Back"
            >
              <i className="icon-close cursor-pointer f-24" />
            </button>
          </div>
        </div>
        <div className="floting-actions">
          {!colouredCardFaces && (RPActiveTab === RP_IDENTIFIER_TAB_KEY ? productIdentifierTabAccess : costingAddEditAccess) && (
            <OverlayTrigger
              placement="top"
              trigger="click"
              rootClose
              overlay={
                <Popover className="custom-popover file-download-popover">
                  <Popover.Content>{rendeDownloadPopover()}</Popover.Content>
                </Popover>
              }
            >
              <button type="button" className="btn" aria-label="Download">
                <CustomTooltip placement="top" tooltipText={t('RANGE_PLANS.PRODUCT_LIST.RP_DOWNLOAD_SHEET')}>
                  <i className="icon-Download" />
                </CustomTooltip>
              </button>
            </OverlayTrigger>
          )}
          {costingAddEditAccess && colouredCardFaces && (
            <OverlayTrigger
              placement="top"
              trigger="click"
              rootClose
              overlay={
                <Popover className="custom-popover file-download-popover">
                  <Popover.Content>{renderDownloadOptionColouredCardFaces()}</Popover.Content>
                </Popover>
              }
            >
              <button type="button" className="btn" aria-label="Download">
                <CustomTooltip placement="top" tooltipText={t('RANGE_PLANS.PRODUCT_LIST.RP_DOWNLOAD_SHEET')}>
                  <i className="icon-Download" />
                </CustomTooltip>
              </button>
            </OverlayTrigger>
          )}

          {rangePlanAddEditAccess && (
            <>
              {(uploadXlsxAccessModule?.includes(RPActiveTab) || (RPActiveTab && RPActiveTab.startsWith('customSections'))) && !colouredCardFaces && identifierUploadAllowed && (
                <CustomTooltip placement="top" tooltipText={t('RANGE_PLANS.PRODUCT_LIST.RP_UPLOAD_SHEET')}>
                  <button type="button" className="btn" aria-label={t('RANGE_PLANS.UPLOAD_PRODUCT_INFORMATION_EXCEL_DOCUMENT')} onClick={uploadXlsx}>
                    <i className="icon-Upload-1 save-icon" />
                  </button>
                </CustomTooltip>
              )}
              {!identifierTabReadOnly && (
                <CustomTooltip placement="top" tooltipText={t('RANGE_PLANS.PRODUCT_LIST.ADD_NOTE')}>
                  <button type="button" onClick={showHideNote} aria-label={t('RANGE_PLANS.PRODUCT_LIST.ADD_NOTE')} className={getNoteClass()}>
                    <i className="icon-Add-Note" />
                  </button>
                </CustomTooltip>
              )}
            </>
          )}
          {!identifierTabReadOnly && (
            <CustomTooltip placement="top" tooltipText={t('RANGE_PLANS.PRODUCT_LIST.DOWNLOAD_LOGS')}>
              <button aria-label="newLocal" type="button" onClick={navigateLog} className="btn ">
                <i className="icon-Preview-Log" />
              </button>
            </CustomTooltip>
          )}
          {(RPActiveTab === 'product-info' || (RPActiveTab && RPActiveTab.includes('custom'))) && (
            <CustomTooltip placement="top" tooltipText={!colouredCardFaces ? t('TAKING_DATES.CARD_VIEW') : t('TAKING_DATES.TABLE_VIEW')}>
              <button
                aria-label="newLocal"
                type="button"
                onClick={() => {
                  if (colouredCardFaces) {
                    history.push(`/rangeplan/product-list/${rangeplanId}`);
                  } else {
                    history.push(`/rangeplan/product-list/${rangeplanId}/visual-view`);
                  }
                }}
                className="btn"
              >
                <i className={!colouredCardFaces ? 'icon-Card-View' : 'icon-Icon-table-view f-26'} />
              </button>
            </CustomTooltip>
          )}
        </div>
      </div>
      <Container fluid className="mt-24">
        <div className="range-plan-container">
          {rangeplanId &&
            menuList?.length > 0 &&
            (colouredCardFaces ? null : (
              <AllInformationTabs
                activeTheTab={activeTheTab}
                masterActiveTab={RPActiveTab}
                MenuList={menuList}
                isAPILoading={mainLoader}
                setSectionData={setSectionData}
              />
            ))}
          {mainLoader ? <Loader /> : renderTableasTab()}
        </div>
      </Container>
      {isNoteVisible && (
        <div className="rangeplan-note">
          <CKEditor
            editor={ClassicEditor}
            data={notes}
            disabled={!rangePlanAddEditAccess}
            config={{
              height: 100,
              toolbar: ['bulletedList', 'numberedList', 'undo', 'redo', 'bold', 'underline'],
            }}
            onChange={(_event, editor) => {
              const data = editor.getData();
              handleChangeComment(data);
            }}
            onBlur={(_event, editor) => {
              const data = editor.getData();
              autoSaveNote(data);
            }}
          />
        </div>
      )}
      {exchangeRateModal && (
        <BulkCostingExchangeModal
          show={exchangeRateModal}
          toggle={openCloseExchangeModal}
          hadleSumbitExchange={hadleSumbitExchange}
          exChangeValue={exchangeRate}
          onChangeExchangeValue={onChangeExchangeValue}
          showLoader={exchangeLoader}
          errors={errors}
        />
      )}
      {isManualModal && (
        <BulkManualModal
          show={isManualModal}
          toggle={openCloseManualModal}
          exChangeValue={exchangeRate}
          onChangeExchangeValue={onChangeExchangeValue}
          showLoader={exchangeLoader}
          selectedIds={selectedIds}
        />
      )}
      {isProductFieldModal && <ProductFieldsModal show={isProductFieldModal} toggle={openCloseProductFieldlModal} selectedIds={selectedIds} />}
      {showUploadModal && (
        <ImportModal
          showUploadModal={showUploadModal}
          closeUploadModal={closeUploadModal}
          docRef={docRef}
          addDocument={handleFile}
          loader={state?.importLoading}
        />
      )}
      {showErrModal && (
        <ErrorModal
          totalCount={state?.totalCount}
          successCount={state?.successCount}
          errorCount={state?.errorCount}
          title={t('RANGE_PLANS.UPLOAD_EXCEL')}
          onOpen={state?.showErrModal}
          toggle={toggleErr}
          handleErrorDownload={handleErrorDownload}
        />
      )}
      {dupModalOpen && (
        <ConfirmationPopup
          onOpen={dupModalOpen}
          toggle={async () => {
            try {
              if (dupData?.file) {
                const response = await fetch(dupData.file);
                const url = new URL(response.url);
                const filename = url.pathname.split('/').pop();
                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(downloadUrl);
              }
            } catch (e) {
              console.error('Download error:', e);
            }
            setState((prev) => ({
              ...prev,
              dupModalOpen: false,
              dupData: null,
            }));
            refreshList();
          }}
          onConfirm={() =>
            runSingleFlight(
              rangePlanDuplicateConfirmLock,
              async () => {
                try {
                  await dispatch(ProductListAction.confirmIncludeDuplicatesUpload({ uploadKey: dupData?.uploadKey, activeTab: 'product-info' }));
                  setState((prev) => ({
                    ...prev,
                    dupModalOpen: false,
                    dupData: null,
                  }));
                  toasterMsg(t('RANGE_PLANS.RP_UPLOAD_CONTINUING') || 'Continuing upload...', 'success');
                  refreshList();
                } catch (e) {
                  console.error(e);
                }
              },
              setIsConfirmingRangePlanDuplicates,
            )
          }
          loading={isConfirmingRangePlanDuplicates}
          disabledBtn={isConfirmingRangePlanDuplicates}
          title={t('RANGE_PLANS.DUPLICATE_FOUND_CONFIRM') || 'Confirm'}
          message={t('RANGE_PLANS.DUPLICATE_FOUND_INCLUDE') || 'Duplicate rows found. Do you want to include duplicates and continue?'}
        />
      )}
    </>
  );
}

export default ProductListNew;
